import { apiClient } from "./client";

export type PageViewPayload = {
  path: string;
  page_title?: string;
  project_id?: string;
  presentation_slug?: string;
  metadata?: Record<string, unknown>;
};

export type ActivityEvent = {
  id: string;
  event_type: string;
  user_id?: string | null;
  email?: string | null;
  auth_method?: string | null;
  path?: string | null;
  page_title?: string | null;
  project_id?: string | null;
  presentation_slug?: string | null;
  metadata: Record<string, unknown>;
  user_agent?: string | null;
  referrer?: string | null;
  client_host_hash?: string | null;
  created_at: string;
};

export type ActivityPageRollup = {
  path: string;
  presentation_slug?: string | null;
  views: number;
  known_viewers: number;
  anonymous_clients: number;
  last_seen?: string | null;
};

export type ActivityViewerRollup = {
  email?: string | null;
  client_host_hash?: string | null;
  events: number;
  page_views: number;
  pages_seen: number;
  last_seen?: string | null;
};

export type ActivitySummary = {
  days: number;
  overview: {
    total_events: number;
    page_views: number;
    known_viewers: number;
    anonymous_clients: number;
    first_seen?: string | null;
    last_seen?: string | null;
  };
  pages: ActivityPageRollup[];
  viewers: ActivityViewerRollup[];
  recent_events: ActivityEvent[];
};

export async function recordPageView(payload: PageViewPayload): Promise<void> {
  await apiClient<void>("/activity/page-view", {
    method: "POST",
    body: payload,
  });
}

export async function fetchActivitySummary(days = 30): Promise<ActivitySummary> {
  return apiClient<ActivitySummary>(`/activity/summary?days=${days}`);
}
